"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var utils_1 = require("../utils");
var warningStyle = {
    pointerEvents: "none",
    padding: 14,
    color: "#fff",
    fontSize: 12,
    fontWeight: "bold",
    backgroundColor: "var(--color-red)",
    border: "solid 1px var(--color-alt-red)",
    borderRadius: 3,
    opacity: .7,
    position: "fixed",
    zIndex: 2147483638,
    bottom: 10,
    left: 10
};
var UIProvider = /** @class */ (function (_super) {
    tslib_1.__extends(UIProvider, _super);
    function UIProvider(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setAppTitle = function (title) {
            var baseTitle = _this.props.config.baseAppTitle;
            var path = [];
            if (baseTitle) {
                path.push(baseTitle);
            }
            if (title) {
                if (title instanceof Array) {
                    path = path.concat(title);
                }
                else {
                    path.push(title);
                }
            }
            utils_1.setDocumentTitle(path.join(" | "));
        };
        _this.unsetAppTitle = function () {
            _this.setAppTitle();
        };
        _this.toggleShowInputNames = function (force) {
            var nextValue = utils_1.isDefined(force) ? force : !_this.state.showInputNames;
            if (_this.state.showInputNames !== nextValue) {
                _this.setState({ showInputNames: nextValue });
            }
        };
        _this.disablePageScroll = function () {
            var $root = _this.getAppRootElement();
            if (!$root) {
                return;
            }
            _this.lastScrollTop = window.pageYOffset;
            utils_1.raf(function () {
                $root.style.position = "fixed";
                $root.style.width = "100%";
                $root.style.minHeight = "100%";
                $root.style.top = "-" + _this.lastScrollTop + "px";
            });
        };
        _this.enablePageScroll = function () {
            var $root = _this.getAppRootElement();
            if (!$root) {
                return;
            }
            utils_1.raf(function () {
                $root.style.position = "";
                $root.style.width = "";
                $root.style.minHeight = "";
                $root.style.top = "";
                window.scrollTo(0, _this.lastScrollTop);
            });
        };
        _this.pushAppContainerFromTop = function (space) {
            var $root = _this.getAppRootElement();
            if (!$root) {
                return;
            }
            $root.style.paddingTop = space && !isNaN(space) ? space + "px" : "";
        };
        _this.state = {
            showInputNames: false
        };
        _this.lastScrollTop = 0;
        return _this;
    }
    UIProvider.prototype.getChildContext = function () {
        return {
            disablePageScroll: this.disablePageScroll,
            enablePageScroll: this.enablePageScroll,
            pushAppContainerFromTop: this.pushAppContainerFromTop,
            linkComponent: this.props.config.linkComponent,
            setAppTitle: this.setAppTitle,
            unsetAppTitle: this.unsetAppTitle,
            toggleShowInputNames: this.toggleShowInputNames,
            showInputNames: this.state.showInputNames
        };
    };
    UIProvider.prototype.getAppRootElement = function () {
        var config = this.props.config;
        if (!config.appContainerSelector) {
            return null;
        }
        return document.querySelector(config.appContainerSelector);
    };
    UIProvider.prototype.render = function () {
        var _a = this.props, config = _a.config, children = _a.children;
        if (process.env.NODE_ENV === "development" &&
            process.env.PROD_API &&
            config.warnDevProductionApiUsage) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { style: warningStyle },
                    React.createElement("span", { style: { fontWeight: "bolder" } }, "WARNING!"),
                    React.createElement("br", null),
                    "You are using a ",
                    React.createElement("u", null, "Production API"),
                    React.createElement("br", null),
                    "on Development environment!"),
                children));
        }
        return this.props.children;
    };
    UIProvider.defaultProps = {
        config: {}
    };
    UIProvider.childContextTypes = {
        disablePageScroll: PropTypes.func,
        enablePageScroll: PropTypes.func,
        pushAppContainerFromTop: PropTypes.func,
        linkComponent: PropTypes.any,
        setAppTitle: PropTypes.func,
        unsetAppTitle: PropTypes.func,
        toggleShowInputNames: PropTypes.func,
        showInputNames: PropTypes.bool
    };
    return UIProvider;
}(React.PureComponent));
exports.default = UIProvider;
